import { useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Navigate } from 'react-router';
import AuthManager from '../../../core/oidc';
import InfoCard from '../../../components/info-card';

const useStyles = makeStyles({
    text: {
        display: 'block',
        textAlign: 'center',
        marginBottom: 15,
    },
});

export default function LoginCallback() {
    const classes = useStyles();
    const [run, setRun] = useState(false);

    useEffect(() => {
        const callback = async () => {
            await AuthManager.loggedInCallback();
            setRun(true);
        };
        callback();
    }, [run]);

    return run ? (
        <Navigate to="/" />
    ) : (
        <InfoCard>
            <h4 className={classes.text}>Lütfen bekleyin...</h4>
        </InfoCard>
    );
}
